module.exports = __webpack_public_path__ + "static/media/axis.8a99e24c.svg";